/**
 * Optimistic SLA meta updates for inbox list rows after send/receive.
 */

/**
 * @param {Record<string, unknown> | null | undefined} slaMeta
 * @param {string} sentAtIso
 */
export function patchSlaMetaForAgentReply(slaMeta, sentAtIso) {
  const meta = slaMeta && typeof slaMeta === "object" ? { ...slaMeta } : {};
  if (!meta.firstHumanAgentAt) meta.firstHumanAgentAt = sentAtIso;
  meta.lastHumanAgentAt = sentAtIso;
  return meta;
}

/**
 * @param {Record<string, unknown> | null | undefined} slaMeta
 * @param {string} sentAtIso
 */
export function patchSlaMetaForUserMessage(slaMeta, sentAtIso) {
  const meta = slaMeta && typeof slaMeta === "object" ? { ...slaMeta } : {};
  if (!meta.firstUserAt) meta.firstUserAt = sentAtIso;
  meta.lastUserAt = sentAtIso;
  return meta;
}

/**
 * @param {Record<string, unknown>} ticket
 * @param {string} sentAtIso
 * @param {{ isNote?: boolean }} [options]
 */
export function patchTicketSlaForAgentReply(ticket, sentAtIso, { isNote = false } = {}) {
  if (isNote) return ticket;
  const next = { ...ticket };
  if (!next.firstAgentReplyAt) next.firstAgentReplyAt = sentAtIso;
  next.lastAgentReplyAt = sentAtIso;
  return next;
}
